var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group input-group-outline mb-3"},[_c('label',{staticClass:"form-label"},[_vm._v("Código")]),_c('input',{staticClass:"form-control",attrs:{"type":"text","maxlength":"11"},domProps:{"value":_vm.maskedCode},on:{"input":_vm.onInput,"paste":_vm.onPaste}})])
}
var staticRenderFns = []

export { render, staticRenderFns }